export const realtorData = {
  email: 'AYALAPROPIEDADES@UNNE.CL',
  phone : '978313358'
  };
